import Logger from "../Logger";

const logger = new Logger("RemoteControl");

export function isRemoteControlDebugEnabled() {
  return Boolean(
    (typeof window !== "undefined" &&
      window.config &&
      window.config.debugRemoteControl) ||
      (typeof window !== "undefined" && window.__WUNITY_RC_DEBUG__)
  );
}

export function rcLog(step, detail) {
  if (!isRemoteControlDebugEnabled()) return;

  if (detail !== undefined) {
    logger.debug("[rc] %s %o", step, detail);
    console.info("[wunity-rc]", step, detail);
  } else {
    logger.debug("[rc] %s", step);
    console.info("[wunity-rc]", step);
  }
}

export function waitForDataProducerOpen(producer, timeoutMs = 15000) {
  if (!producer) return Promise.resolve();

  if (producer.readyState === "open") return Promise.resolve();

  return new Promise((resolve, reject) => {
    const timer = setTimeout(() => {
      cleanup();
      reject(new Error("remote control dataproducer open timeout"));
    }, timeoutMs);

    const onOpen = () => {
      cleanup();
      resolve();
    };

    const onClose = () => {
      cleanup();
      reject(new Error("remote control dataproducer closed before open"));
    };

    const cleanup = () => {
      clearTimeout(timer);
      producer.off("open", onOpen);
      producer.off("close", onClose);
    };

    producer.on("open", onOpen);
    producer.on("close", onClose);
  });
}
